import { useQuery } from '@tanstack/react-query';
import { BENE_MEMBERS_KEY } from '../../utils/constants/queryKeys';
import { getBeneMembers } from '../services/fn-api/Beneficiary';

export const useGetMembers = (beneId: number) => {
  return useQuery({
    queryKey: [BENE_MEMBERS_KEY],
    queryFn: () => getBeneMembers(beneId),
    retry: false,
  });
};
